import { render } from "./shop-menu.vue?vue&type=template&id=bf63210c"
import script from "./shop-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./shop-menu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/shop/shop-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf63210c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf63210c', __exports__)) {
    api.reload('bf63210c', __exports__)
  }
  
  module.hot.accept("./shop-menu.vue?vue&type=template&id=bf63210c", () => {
    api.rerender('bf63210c', render)
  })

}


export default __exports__